export const BOOKING_CALENDAR_MESSAGES_COLLECTION =
  "bookingCalendarMessages";

export const BOOKING_CALENDAR_MESSAGE_MAX_LENGTH = 2000;

const normalizeRoles = (roles = []) =>
  (Array.isArray(roles) ? roles : [])
    .map((role) => String(role || "").trim())
    .filter(Boolean);

export const canViewBookingCalendarMessages = (roles = []) => {
  const normalizedRoles = normalizeRoles(roles);
  const isBookingAdmin = normalizedRoles.some((role) =>
    ["super_admin", "admin"].includes(role),
  );

  return (
    normalizedRoles.length > 0 &&
    (isBookingAdmin || !normalizedRoles.includes("staff"))
  );
};

export const canDeleteBookingCalendarMessages = (roles = []) =>
  normalizeRoles(roles).some((role) =>
    ["super_admin", "admin"].includes(role),
  );

const getTimestampMilliseconds = (value) => {
  if (!value) return 0;

  if (typeof value.toMillis === "function") {
    return value.toMillis();
  }

  if (typeof value.toDate === "function") {
    return value.toDate().getTime();
  }

  const parsedDate = value instanceof Date ? value : new Date(value);
  const milliseconds = parsedDate.getTime();
  return Number.isNaN(milliseconds) ? 0 : milliseconds;
};

export const normalizeBookingCalendarMessage = (messageDoc = {}) => {
  const data =
    messageDoc && typeof messageDoc.data === "function"
      ? messageDoc.data()
      : messageDoc || {};
  const createdBy =
    data.createdBy && typeof data.createdBy === "object"
      ? data.createdBy
      : {};

  return {
    id: String(messageDoc.id || data.id || "").trim(),
    calendarDate: String(data.calendarDate || data.date || "").trim(),
    message: String(data.message || data.text || "").trim(),
    createdAt: data.createdAt || null,
    createdBy: {
      uid: String(createdBy.uid || data.createdByUid || "").trim(),
      name: String(
        createdBy.name ||
          createdBy.displayName ||
          data.createdByName ||
          data.authorName ||
          "",
      ).trim(),
      email: String(createdBy.email || data.createdByEmail || "").trim(),
      role: String(createdBy.role || data.createdByRole || "").trim(),
    },
  };
};

export const groupBookingCalendarMessagesByDate = (messages = []) => {
  const messagesByDate = {};

  (Array.isArray(messages) ? messages : []).forEach((message) => {
    if (!message || !message.calendarDate || !message.message) return;

    if (!messagesByDate[message.calendarDate]) {
      messagesByDate[message.calendarDate] = [];
    }

    messagesByDate[message.calendarDate].push(message);
  });

  Object.keys(messagesByDate).forEach((calendarDate) => {
    messagesByDate[calendarDate].sort(
      (messageA, messageB) =>
        getTimestampMilliseconds(messageB.createdAt) -
          getTimestampMilliseconds(messageA.createdAt) ||
        String(messageB.id || "").localeCompare(String(messageA.id || "")),
    );
  });

  return messagesByDate;
};
